import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ApiService } from "../services/api.service";

@Component({
  selector: 'app-start-meeting',
  templateUrl: './start-meeting.component.html',
  styleUrls: ['./start-meeting.component.css']
})
export class StartMeetingComponent implements OnInit {

  
  meetingID:any;
  password:any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public ApiServiceCall: ApiService,

  ) {
this.meetingID;
this.password;

   }

  ngOnInit(): void {
   
    this.meetingID = this.makeid(9);
    this.password = this.makepassword(6);
  }
  onStartMeeting() {
    var obj = {
    meetingId: this.meetingID,
    password: this.password,
    isAudioEnabled: 1,
    isVideoEnabled: 1
    };
    this.ApiServiceCall.startMeeting(obj).subscribe((data) => {
   
      this.router.navigate(['meeting/'+this.meetingID]);
      
  });
  }
 makeid(length) {
    var result           = '';
    var characters       = '0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
       result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
 }

 makepassword(length) {
  var result           = '';
  var characters       = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
     result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

}
